import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import DataGridCell from 'components/common/DataGridCell';

export function baseCell<T>(params: GridRenderCellParams<T>) {
  return <DataGridCell content={params.value as string} />;
}
